import { ChangeEvent, InputHTMLAttributes, useState } from 'react';
import cn from 'classnames';
import styles from './styles/TextInput.module.scss';

export interface TextInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  onChange: (value?: string) => void;
  hasError?: boolean;
}

export default function TextInput({ className, onChange, value, hasError, ...props }: TextInputProps) {
  const [isDirty, setIsDirty] = useState(false);

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    setIsDirty(true);
    onChange(e.target.value === '' ? undefined : e.target.value);
  }

  return (
    <input
      className={cn(styles.TextInput, { [styles.Dirty]: isDirty, [styles.Error]: hasError }, className)}
      onChange={handleChange}
      value={value === undefined || value === null ? '' : value}
      {...props}
    />
  );
}
